export default {
  "widget.defaultTitle": "Discutez avec nous",
  "widget.defaultSubtitle": "Nous sommes là pour vous aider",
  "widget.defaultGreeting": "Bonjour ! Comment pouvons-nous vous aider aujourd'hui ?",
  "chat.close": "Fermer le chat",
  "chat.open": "Ouvrir le chat",
  "chat.expand": "Agrandir le chat",
  "chat.collapse": "Réduire le chat",
  "chat.conversationEnded": "Cette conversation est terminée",
  "chat.startNew": "Démarrer une Nouvelle Conversation",
  "chat.poweredBy": "Propulsé par",
  "chat.conversationClosed": "Conversation Fermée",
  "chat.aiLabel": "Assistant IA",
  "input.placeholder": "Écrivez un message...",
  "input.send": "Envoyer le message",
  "error.sendFailed": "Impossible d'envoyer votre message. Veuillez réessayer dans un instant.",
  "error.messageTooLong": "Votre message est trop long. Veuillez le raccourcir et réessayer.",
  "chat.teamMember": "Un membre de l'équipe",
  "chat.agentJoined": "{name} a rejoint la conversation",
  "chat.agentLeft": "{name} a quitté la conversation",
  "chat.agentReturnedToAi":
    "{name} a quitté la conversation. Vous échangez de nouveau avec l'assistant IA.",
  "availability.open": "Ouvert",
  "availability.backAt": "Retour {when}",
  "availability.closed": "Absent pour le moment",
  "waiting.title": "En attente d'une personne",
  "waiting.typical": "Répond généralement en {time}",
  "waiting.alerted": "Nous avons prévenu l'équipe.",
  "waiting.closed":
    "L'équipe revient {when}. D'ici là, l'assistant IA peut continuer à vous aider.",
  "waiting.minutes": "~{n} min",
  "waiting.hours": "~{n} h",
  "contact.prompt":
    "Laissez votre e-mail et nous vous enverrons la réponse de l'équipe si vous êtes parti.",
  "contact.label": "E-mail",
  "contact.placeholder": "vous@exemple.fr",
  "contact.submit": "Me prévenir",
  "contact.consent": "Nous utiliserons votre e-mail uniquement pour répondre à cette conversation.",
  "contact.saved":
    "Merci ! Si vous êtes parti quand l'équipe répond, nous vous enverrons un e-mail.",
  "contact.failed": "Impossible d'enregistrer votre e-mail. Vérifiez-le et réessayez.",
  "input.attach": "Joindre une photo ou un PDF",
  "error.fileTooLarge": "Ce fichier est trop volumineux. Photos et PDF jusqu'à 10 Mo.",
  "error.fileType": "Vous pouvez envoyer des photos (JPG, PNG, GIF, WebP) ou des PDF.",
  "error.fileFailed": "Impossible d'envoyer votre fichier. Essayez-en un autre.",
  "attachment.photo": "Photo",
  "attachment.file": "Fichier",
  "attachment.sending": "Envoi...",
  "error.verificationFailed": "Nous n'avons pas pu vérifier votre message. Veuillez actualiser la page et réessayer.",
  "challenge.label": "Vérification de sécurité",
  "challenge.prompt": "Une vérification de sécurité rapide avant d'envoyer votre message.",
  "csat.defaultQuestion": "Comment évalueriez-vous l'assistance reçue aujourd'hui ?",
  "csat.thankYou": "Merci pour votre retour !",
} as const;
